"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcInvoiceReferences = exports.InvoiceReferenceSearchOption = exports.InvoiceReferenceSearch = exports.InvoiceReferenceItem = void 0;
const InvoiceReferenceItem_yaml_component_1 = __importDefault(require("./InvoiceReferenceItem.yaml?component"));
exports.InvoiceReferenceItem = InvoiceReferenceItem_yaml_component_1.default;
const InvoiceReferenceSearch_yaml_component_1 = __importDefault(require("./InvoiceReferenceSearch.yaml?component"));
exports.InvoiceReferenceSearch = InvoiceReferenceSearch_yaml_component_1.default;
const InvoiceReferenceSearchOption_yaml_component_1 = __importDefault(require("./InvoiceReferenceSearchOption.yaml?component"));
exports.InvoiceReferenceSearchOption = InvoiceReferenceSearchOption_yaml_component_1.default;
const UcInvoiceReferences_yaml_component_1 = __importDefault(require("./UcInvoiceReferences.yaml?component"));
exports.UcInvoiceReferences = UcInvoiceReferences_yaml_component_1.default;
